import React from 'react';
import { WindowStateContext } from './windowStateContext';

export let useWindowState = () => React.useContext(WindowStateContext);
